import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import Image from "next/image"
import SwiperCore from "swiper"
import "swiper/css"
import { Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import { getUmbracoMediaUrl } from "utils"
import { transformProperties } from "utils/simplifyData"
import { colors } from "./theme/colors"
SwiperCore.use([Pagination])

const StyledSwiper = styled(Swiper)`
  .swiper-pagination {
    position: absolute;
    height: 14px;

    .swiper-pagination-bullet {
      width: 14px;
      height: 14px;
      background: transparent;
      border: solid 1px ${colors.red};
      opacity: 1;
    }

    .swiper-pagination-bullet-active {
      background: ${colors.red};
    }
  }
`

const StyledSwiperSlide = styled(SwiperSlide)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

const StyledText = styled(Typography)`
  text-align: center;
`

const CarouselItemsImageAndText = ({ data }: any) => {
  return (
    <StyledSwiper pagination={{ clickable: true }}>
      {data?.map((item: any, index: number) => {
        const { title, text, image } = transformProperties(item?.properties)
        return (
          <StyledSwiperSlide key={`carousel-item-${index}`}>
            {image && (
              <Image
                src={getUmbracoMediaUrl(image?.mediaItems[0]?.url)}
                alt={title?.value}
                width={120}
                height={130}
              />
            )}

            <Typography variant="body3" fontWeight={700}>
              {title?.value}
            </Typography>
            <StyledText variant="body2">{text?.value}</StyledText>
          </StyledSwiperSlide>
        )
      })}
    </StyledSwiper>
  )
}

export default CarouselItemsImageAndText
